import $ from "jquery";
import { GraphForm } from "./graph_form";
import { ConditionPanel } from "./condition_panel";

// Interface definitions
interface InvalidParameterCombination {
  type?: string;
  partition?: string;
  hasDimension?: boolean;
}

interface HttpErrorResponse {
  status: number;
  statusText?: string;
  [key: string]: any;
}

declare global {
  interface Window {
    tablemill: any;
  }
}

class CombinationComparisonsView extends GraphForm {
  private conditionPanel: ConditionPanel;

  constructor(formElement: JQuery) {
    super();
    this.conditionPanel = new ConditionPanel(
      formElement,
      this.isCombinationComparisonsView(),
    );
  }

  // Element getters
  private dimensionElement(): JQuery {
    return $("#dimension");
  }

  private canvasElement(): JQuery {
    return $("#characteristics_graph");
  }

  private stderrElement(): JQuery {
    return $("#error_message_placeholder");
  }

  // Configuration methods
  isCombinationComparisonsView(): boolean {
    return true;
  }

  // Initialization
  initialize(
    invalidParameterCombinations: InvalidParameterCombination[],
  ): void {
    this.conditionPanel.initialize(invalidParameterCombinations);
  }

  // Rendering methods
  render(html: string): void {
    this.canvasElement().html(html);
    this.enableCsvButton($(".characteristics_graph_box .csv_button"));
  }

  // Message display methods
  showKeywordNotFoundMessage(keyword: string): void {
    this.drawMessage(`
      「${keyword}」は見付かりませんでした。
      別の単語をお試しください。
    `);
  }

  showNoCombinationsMessage(): void {
    this.drawMessage(`
      この条件ではデータが存在しません。 期間や集計単位を変更してお試しください。
    `);
  }

  showHttpErrorMessage(response: HttpErrorResponse): void {
    const currentDate = new Date().toLocaleString("ja-JP");
    this.drawErrorMessage(`
      申し訳ありません、通信エラーが発生しました。
      少し時間をおいて再度お試しください。
      ステータス: ${response.status}, ${currentDate}
    `);
  }

  // Core drawing methods
  drawMessage(message: string): void {
    // HTMLエスケープ処理
    const trimmedMessage = message.trim();
    const escapedMessage = $("<div>").text(trimmedMessage).html();
    this.canvasElement().html(`<p class='message'>${escapedMessage}</p>`);
  }

  drawErrorMessage(message: string): void {
    // HTMLエスケープ処理と改行変換
    const trimmedMessage = message.trim();
    const escapedMessage = $("<div>").text(trimmedMessage).html();
    const messageWithBreaks = escapedMessage.replace(/\n/g, "<br/>");
    this.canvasElement().html(
      `<p class='error_message'>${messageWithBreaks}</p>`,
    );
  }

  // Specialized message methods
  showNoDataMessage(): void {
    this.drawMessage(`
      指定された条件ではデータが見つかりませんでした。
      検索条件を変更してお試しください。
    `);
  }
}

export { CombinationComparisonsView };
